/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import * as MsDyn365 from '@msdyn365-commerce/core';

import { IEshopFaqData } from './eshop-faq.data';
import { IEshopFaqProps } from './eshop-faq.props.autogenerated';
import {  INodeProps } from '@msdyn365-commerce-modules/utilities';

export interface IEshopFaqViewProps extends IEshopFaqProps<IEshopFaqData> {
    information: React.ReactNode;
    faqDescription: React.ReactNode;
    faqDetailsContainerProps: INodeProps;
    faqDetails?: React.ReactNode;
}

/**
 *
 * EshopFaq component
 * @extends {React.PureComponent<IEshopFaqProps<IEshopFaqData>>}
 */
class EshopFaq extends React.PureComponent<IEshopFaqProps<IEshopFaqData>> {
    public render(): JSX.Element | null {

        const {
            slots: {
                faqSection
            },
            config
        } = this.props;

        const information = config.information && <MsDyn365.RichTextComponent text={config.information} editProps={{onEdit: this._handleFaqDescription, requestContext:this.props.context.request}} />;

        const faqText = config.faqDescription && <MsDyn365.RichTextComponent text={config.faqDescription} editProps={{onEdit: this._handleFaqDescription, requestContext:this.props.context.request}} />;

        
    const EshopFaqViewProps = {
        ...this.props,
        information: information,
        faqDescription: faqText,
        faqDetailsContainerProps:{
            className: 'eshop-faq__faq-details-display'
        },
        faqDetails: faqSection && faqSection.length>0? faqSection[0]:undefined
      };

        return this.props.renderView(EshopFaqViewProps);
    }

    private _handleFaqDescription = (event: MsDyn365.ContentEditableEvent) => this.props.config.faqDescription = event.target.value;
}

export default EshopFaq;
